<template>
    <div class="w-full">

        <h4 class="mb-3">{{ $t('Users') }}</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addUserPrompt = true">
            {{ $t('Add') }}</vs-button>

        <vx-card id="usersDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openUser" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">{{ $t('UserName') }}</vs-th>
                    <vs-th sort-key="email">{{ $t('UserEmail') }}</vs-th>
                    <vs-th sort-key="admin_user">{{ $t('UserAdmin') }}</vs-th>
                    <vs-th sort-key="key_id">{{ $t('RFIDId') }}</vs-th>
                    <vs-th sort-key="access_group_name">{{ $t('AccessGroup') }}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].email">
                            {{data[index].email}}
                        </vs-td>

                        <vs-td :data="data[index].admin_user">
                            <vs-chip v-if="data[index].admin_user" color="success">
                                {{$t('Yes')}}
                            </vs-chip>
                            <vs-chip v-else color="danger">
                                {{$t('No')}}
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].key_id">
                            {{ data[index].key_id }}
                        </vs-td>

                        <vs-td :data="data[index].access_group_name">
                            {{ data[index].access_group_name }}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup :title="$t('AddUser')" :active.sync="addUserPrompt">
            <div id="addUserDiv" class="vs-con-loading__container" >
                <vs-checkbox class="mt-3" v-model="addObject['admin_user']">{{ $t('UserAdmin') }}</vs-checkbox>
                <p class="mt-6">{{ $t('UserName') }}</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">{{ $t('UserEmail') }}</p>
                <vs-input v-model="addObject['email']" class="w-full"></vs-input>
                <p class="mt-6">{{ $t('UserPassword') }}</p>
                <vs-input type="password" v-model="addObject['password']" class="w-full"></vs-input>
                <p class="mt-6">{{ $t('RFIDId') }}</p>
                <vs-input v-model="addObject['key_id']" class="w-full"></vs-input>
                <p class="mt-6">{{ $t('AccessGroup') }}</p>
                <vs-select autocomplete class="w-full" v-model="addObject['access_group_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in accessGroups" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addUser">{{ $t('Add') }}</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                itemsPerPage: 20,
                isMounted: false,

                users: [],
                accessGroups: [],

                addUserPrompt: false,

                addObject: {
                }
            }
        },
        methods: {
            openUser(tr) {
                this.$router.push(`/user/${ tr.id}`)
            },
            loadData() {
                this.$vs.loading({
                    container: '#usersDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/client_user/')
                loadPromise.then(function(response) {
                    thisIns.users = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const groupsPromise = this.$http.get('/api/management/v1/client_user_access_group/')
                groupsPromise.then(function(response) {
                    thisIns.accessGroups = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, groupsPromise]).finally(function() {
                    thisIns.$vs.loading.close('#usersDiv > .con-vs-loading')
                })
            },
            addUser() {
                this.$vs.loading({
                    container: '#addUserDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/client_user/', {
                    name: this.addObject.name,
                    email: this.addObject.email,
                    password: this.addObject.password,
                    key_id: this.addObject.key_id,
                    admin_user: this.addObject.admin_user,
                    web_access_allowed: false,
                    access_group_id: Number(this.addObject.access_group_id)
                })

                addPromise.then(function(response) {
                    thisIns.addUserPrompt = false
                    thisIns.$printSuccess(thisIns.$t('UserAdded'))
                    thisIns.$nextTick(() => {
                        thisIns.$router.push(`/user/${ response.data}`)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addUserDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.users
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }
    }
</script>
